
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Button } from 'react-bootstrap';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';

import ListCoverPhoto from '../../ListCoverPhoto';
import ListGridCoverPhoto from '../../ListGridCoverPhoto';
import ImageSlider from '../ImageSlider';
import WishListIcon from '../../WishListIcon';
import ListDefaultPhoto from '../../ListDefaultPhoto';
import VideoPreview from '../../VideoPreview';

import { openImageLightBox, closeImageLightBox } from '../../../actions/ImageLightBox';
import { setStickyTop } from '../../../actions/Sticky/StrickyActions';
import { openSocialShareModal } from '../../../actions/modalActions';
import messages from '../../../locale/messages';
import { photosShow } from '../../../helpers/photosShow';
import { fileuploadDir } from '../../../config';
import { toWebp } from '../../../helpers/imageHelper';

import s from './Photos.css';
import cs from '../../../components/commonStyle.css';

//Images
import photoImage from '/public/siteImages/gallery.svg';

class Photos extends React.Component {
  static propTypes = {
    listPhotos: PropTypes.array,
    coverPhoto: PropTypes.number,
    openImageLightBox: PropTypes.any.isRequired,
    closeImageLightBox: PropTypes.any.isRequired,
    imageLightBox: PropTypes.bool.isRequired,
    formatMessage: PropTypes.any,
  };

  static defaultProps = {
    listPhotos: [],
    imageLightBox: false
  }

  constructor(props) {
    super(props);
    this.state = {
      sources: [],
      isHovering: false
    }
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter() {
    this.setState({ isHovering: true });
  }

  handleMouseLeave() {
    this.setState({ isHovering: false });
  }

  componentDidMount() {
    const { data, setStickyTop } = this.props;
    let sources = [], sourceObject = {}, coverPhoto;
    let sticky = document.querySelector('[data-sticky-top]'), stickyHeight = 412;
    let path = photosShow(fileuploadDir);

    if (data.listPhotos != null && data.listPhotos.length > 0) {
      coverPhoto = data.listPhotos[0].name;

      if (data.coverPhoto != undefined && data.coverPhoto != null) {

        data.listPhotos.map((item, key) => {
          if (item.id === data.coverPhoto) {
            sourceObject = {};
            sourceObject['src'] = `${path}x_large_` + toWebp(item.name);
            sources.push(sourceObject);
          }
        });

        data.listPhotos.map((item, key) => {
          if (item.id != data.coverPhoto) {
            sourceObject = {};
            sourceObject['src'] = `${path}x_large_` + toWebp(item.name);
            sources.push(sourceObject);
          }
        });

      } else {
        data.listPhotos.map((item, key) => {
          sourceObject = {};
          sourceObject['src'] = `${path}x_large_` + toWebp(item.name);
          sources.push(sourceObject);
        });
      }
      this.setState({ sources });
    }
    stickyHeight = (sticky.getBoundingClientRect().height + 10);
    setStickyTop(stickyHeight);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { data } = nextProps;
    let sources = [], sourceObject = {}, coverPhoto;
    let sticky = document.querySelector('[data-sticky-top]'), stickyHeight = 412;
    let path = photosShow(fileuploadDir);

    if (data.listPhotos != null && data.listPhotos.length > 0) {

      coverPhoto = data.listPhotos[0].name;

      if (data.coverPhoto != undefined && data.coverPhoto != null) {

        data.listPhotos.map((item, key) => {
          if (item.id === data.coverPhoto) {
            sourceObject = {};
            sourceObject['src'] = `${path}x_large_` + toWebp(item.name);
            sources.push(sourceObject);
          }
        });

        data.listPhotos.map((item, key) => {
          if (item.id != data.coverPhoto) {
            sourceObject = {};
            sourceObject['src'] = `${path}x_large_` + toWebp(item.name);
            sources.push(sourceObject);
          }
        });

      } else {
        data.listPhotos.map((item, key) => {
          sourceObject = {};
          sourceObject['src'] = `${path}x_large_` + toWebp(item.name);
          sourceObject['src'] = `${path}x_large_` + toWebp(item.name);
          sources.push(sourceObject);
        });
      }

      this.setState({ sources });
    }
    stickyHeight = (sticky.getBoundingClientRect().height + 10);
    setStickyTop(stickyHeight);
  }

  openSliderClick = () => {
    const { openImageLightBox } = this.props;
    let root = document.getElementsByTagName('html')[0];
    root.classList.add('scrollHidden');
    openImageLightBox();
  }
  // In your Photos component, replace the rendering logic with this:

  render() {
    const { sources, isHovering } = this.state;
    const { data, closeImageLightBox, imageLightBox, openSocialShareModal, loading } = this.props;

    let coverPhoto = data.coverPhoto;
    let listPhotos = data.listPhotos;
    let wishListStatus = data.wishListStatus;
    let isListOwner = data.isListOwner;
    let youtubeVideoId = data.youtubeVideoId;

    return (
      <div className={cx(s.bannerContainer)} data-sticky-top>
        <ImageSlider
          imageLightBox={imageLightBox}
          closeImageLightBox={closeImageLightBox}
          sources={sources}
        />

        {/* Show default photo only when there are NO photos */}
        {
          (!listPhotos || listPhotos.length === 0) && <ListDefaultPhoto
            className={s.bannerImage}
            coverPhoto={coverPhoto}
            listPhotos={listPhotos}
            photoType={"xx_large"}
            bgImage
          />
        }

        {/* Show ListGridCoverPhoto for 1 or more images */}
        {
          sources && sources.length > 0 && (
            <div 
              onClick={this.openSliderClick} 
              className={s.gridPadding}
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
              style={{ position: 'relative' }}
            >
              {/* VideoPreview overlay on main photo */}
              {youtubeVideoId && (
                <VideoPreview
                  youtubeUrl={youtubeVideoId}
                  isOverlay={true}
                  isHovering={isHovering}
                  isDetailPage={true}
                />
              )}
              <ListGridCoverPhoto
                className={s.bannerImage}
                coverPhoto={coverPhoto}
                listPhotos={sources}
                photoType={"xx_large"}
                bgImage
              >
                <Button
                  className={cx(s.viewPhotosBtn, 'viewPhotosBtnRTL', cs.commonMediumText, cs.fontWeightMedium)}
                  onClick={this.openSliderClick}
                >
                  <img src={photoImage} className={cx(s.photoImage, 'commonIconSpace')} />
                  <FormattedMessage {...messages.showAllPhotos} />
                </Button>
              </ListGridCoverPhoto>
            </div>
          )
        }
      </div>
    );
  }
}

const mapState = (state) => ({
  imageLightBox: state.viewListing.imageLightBox
});

const mapDispatch = {
  openImageLightBox,
  closeImageLightBox,
  setStickyTop,
  openSocialShareModal
};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(Photos)));